<div class="meeting-details-view-container" *ngIf="meetingObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="meetingObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + meetingObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="meetingObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).meeting.write " (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button [disabled]="!((userPermissions | async).meeting.delete && meetingObject.createdBy.uuid === userProfile.userId) && !(userPermissions | async).meeting.admin_root " (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
    <button *ngIf="meetingObject?.filename" mat-stroked-button color="accent" aria-label="Pobierz agendę" (click)="downloadFile(meetingObject.uuid)" class="flout">
      <mat-icon>download</mat-icon> Pobierz Agendę
    </button>
    <button *ngIf="(userPermissions | async).meeting.read_report && (meetingObject.type.key === MEETING_TYPE_EXAM || meetingObject.type.key === MEETING_TYPE_NEW_AGENT_TRAINING || meetingObject.type.key === MEETING_TYPE_IDD_TRAINING || meetingObject.type.key === MEETING_TYPE_ENTRANCE_EXAM)" [disabled]="!(userPermissions | async).meeting.read_report" mat-stroked-button (click)="downloadReport()">
      <mat-icon>download</mat-icon> Raport
    </button>

  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" [fxFlex]="meetingObject.address ? '50' : '100'" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <div>
                <div class="user-avatar" *ngIf="meetingObject.insuranceCompany?.imageLocation"
                     matRipple
                     [matRippleCentered]="false"
                     [matRippleDisabled]="false"
                     [matRippleUnbounded]="false"
                     [matRippleRadius]="10"
                     [matRippleColor]="'grey'" >
                  <img src="/rest/crm/insuranceCompany/{{meetingObject.insuranceCompany?.id}}/image" alt="Zdjęcie" height="60"/>
                </div>
              </div>
              <h3>Dane</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail [fxFlex]="meetingObject?.leader ? '50' : '100'" header="Rodzaj" [value]="meetingObject.type.name"></app-detail>

              <app-detail *ngIf="meetingObject?.leader" [fxFlex]="meetingObject.leader.id === 229 ? '25' : '50'" header="Organizator" [value]="meetingObject.leader.name"></app-detail>

              <app-detail *ngIf= "meetingObject.iddTrainingTrainer" fxFlex="25" header="Prowadzący szkolenie" [value]="meetingObject.iddTrainingTrainer.firstName + ' ' + meetingObject.iddTrainingTrainer.lastName"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="meetingObject.insuranceCompany">
              <app-detail fxFlex="100" header="TU" [value]="meetingObject.insuranceCompany.name"></app-detail>

            </div>

            <div fxLayout="row" *ngIf="meetingObject.type.key !== MEETING_TYPE_EXAM && meetingObject.type.key !== MEETING_TYPE_ENTRANCE_EXAM && meetingObject.type.key !== MEETING_TYPE_NEW_AGENT_TRAINING && meetingObject.type.key !== MEETING_TYPE_IDD_TRAINING  && meetingObject.subject">
              <app-detail fxFlex="100" header="Prowadzący" [value]="meetingObject.meetingLeading"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="meetingObject.type.key !== MEETING_TYPE_EXAM && meetingObject.type.key !== MEETING_TYPE_ENTRANCE_EXAM && meetingObject.type.key !== MEETING_TYPE_NEW_AGENT_TRAINING  && meetingObject.subject">
              <app-detail fxFlex="100" header="Temat" [value]="meetingObject.subject"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="meetingObject.type.key === MEETING_TYPE_IDD_TRAINING">
              <app-detail fxFlex="50" header="Liczba minut - majątek" [value]="meetingObject.minutesAssets?.toString()"></app-detail>

              <app-detail fxFlex="50" header="Liczba minut - życie" [value]="meetingObject.minutesLife?.toString()"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="meetingObject.type.key === MEETING_TYPE_EXAM || MEETING_TYPE_ENTRANCE_EXAM">
              <app-detail fxFlex="100" header="Rodzaj egzaminu" [value]="meetingObject?.examType?.name"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Data rozpoczęcia" [value]="meetingObject.startsAt | date:'y-MM-dd HH:mm'"></app-detail>

              <app-detail *ngIf="meetingObject.thematicScope.length <= 0" fxFlex="50" header="Czas trwania" [value]="meetingHours + ' godz. ' + meetingMinutes + ' min.'"></app-detail>
              <app-detail *ngIf="meetingObject.thematicScope.length > 0" fxFlex="50" header="Czas trwania" [value]="(meetingObject.minutesTotal - (meetingObject.minutesTotal%60) )/ 60 + ' godz. '+meetingObject.minutesTotal%60 + ' min.'"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" >
              <app-detail fxFlex="50" header="Data zakończenia" [value]="meetingObject.endsAt | date:'y-MM-dd HH:mm'"></app-detail>
<!--              <div fxFlex="50"></div>-->
<!--            </div>-->

<!--            <div fxLayout="row">-->
              <app-detail fxFlex="50" header="Typ" [value]="meetingObject.place.name"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="meetingObject.link">
              <app-detail fxFlex="100" header="Link" [value]="meetingObject.link" [externalLink]="meetingObject.link"></app-detail>
            </div>

            <div fxLayout="row" >
              <app-detail  [fxFlex]="100" header="Organizator" [value]="meetingObject?.createdBy.firstName +' '+ meetingObject?.createdBy.lastName"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Do kiedy można zapisywać" [value]="meetingObject.registrationsTo | date:'y-MM-dd HH:mm'"></app-detail>

              <div fxFlex="50" fxLayout="row" fxLayoutGap="15px">
                <app-detail fxFlex="50" header="Pozostało miejsc" [value]="meetingObject.placesLeft?.toString()"></app-detail>

                <app-detail fxFlex="50" header="Limit osób" [value]="meetingObject.limitOfPeople?.toString()"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center" *ngIf="meetingObject.type.key !== MEETING_TYPE_EXAM && meetingObject.type.key !== MEETING_TYPE_ENTRANCE_EXAM && meetingObject.place.key==='stationary'" >
              <app-detail-bool [fxFlex]="25" header="Posiłek" [value]="meetingObject.meal"></app-detail-bool>

              <app-detail-bool [fxFlex]="25" header="Nocleg" [value]="meetingObject.accommodation"></app-detail-bool>

              <app-detail-bool [fxFlex]="25" header="Centrala ASF" [value]="meetingObject.central"></app-detail-bool>

              <app-detail-bool [fxFlex]="25" header="Loża PGE" [value]="meetingObject.pge"></app-detail-bool>

              <app-detail *ngIf="meetingObject.central" [fxFlex]="25" header="Sala" [value]="meetingObject.room.name"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px"  fxLayoutAlign=" center" *ngIf="meetingObject?.accommodation || meetingObject?.meal" >
              <div fxFlex="25">
                <app-detail *ngIf="meetingObject?.accommodationDetail" [fxFlex]="100" header="Szczegóły" [value]="meetingObject?.accommodationDetail"></app-detail>
              </div>
              <div fxFlex="25">
                <app-detail *ngIf="meetingObject?.mealDetail" [fxFlex]="100" header="Szczegóły" [value]="meetingObject?.mealDetail"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" fxFlex.lt-md="100%" *ngIf="meetingObject.thematicScope.length > 0">
        <div fxFlex="100" fxLayoutGap="15px">
          <mat-expansion-panel >
            <mat-expansion-panel-header>
              <div fxLayout="row" >
                <h3>Zakres tematyczny szkolenia</h3>
              </div>
            </mat-expansion-panel-header>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container *ngFor="let thematicScope of meetingObject.thematicScope; let i = index">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Data rozpoczęcia" [value]="thematicScope.thematicScopeStartsAt | date:'y-MM-dd ' + thematicScope.thematicScopeStartsAtTime"></app-detail>
                    <app-detail fxFlex="50" header="Czas trwania" [value]="(thematicScope.thematicScopeMinutesTotal - (thematicScope.thematicScopeMinutesTotal%60) )/ 60 + ' godz. '+thematicScope.thematicScopeMinutesTotal%60 + ' min.'"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Data zakończenia" [value]="thematicScope.thematicScopeEndsAt | date:'y-MM-dd ' + thematicScope.thematicScopeEndsAtTime"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="100" header="Temat" [value]="thematicScope.thematicScopeSubject"></app-detail>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>

        </div>
      </div>


    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" *ngIf="meetingObject.address">
      <app-detail-address header="Adres" [address]="meetingObject.address"></app-detail-address>
    </div>

  </div>


</div>
